import { render, staticRenderFns } from "./Txt.vue?vue&type=template&id=275b155d&scoped=true&lang=pug&"
import script from "./Txt.vue?vue&type=script&lang=js&"
export * from "./Txt.vue?vue&type=script&lang=js&"
import style0 from "./Txt.vue?vue&type=style&index=0&id=275b155d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b155d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('275b155d', component.options)
    } else {
      api.reload('275b155d', component.options)
    }
    module.hot.accept("./Txt.vue?vue&type=template&id=275b155d&scoped=true&lang=pug&", function () {
      api.rerender('275b155d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/built-in component/Txt.vue"
export default component.exports